// src/icons/Minus.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Minus({
  strokeWidth = "1.5",
  strokeLinecap = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.75 12H17.25",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap
        }
      )
    }
  );
}

export {
  Minus
};
